import { useMutation, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import Status from "components/base/Status";
import PageV2 from "components/shared/PageV2";
import moment from "moment";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CREATE_ORDER, SAPES_GET_ORDERS } from "./graphql";

const OrderList = () => {
  const { odooUrl } = useContext(OdooContext);
  const navigate = useNavigate();
  const { loading, error, data } = useQuery(SAPES_GET_ORDERS, {
    fetchPolicy: "network-only",
  });
  const [createOrder, createOrderRes] = useMutation(CREATE_ORDER, {
    onCompleted: (data) => {
      navigate(`/sales/orders/${data.createOrder.order.id}`);
    },
    onError: (error) => {
      console.log(error);
    },
    refetchQueries: ["SAPES_GET_ORDERS"],
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <PageV2 title="Sales Orders">
      <div className="h-full flex flex-col space-y-4">
        <div className="flex space-x-4 items-center">
          <Button onClick={createOrder} loading={createOrderRes.loading}>
            + Create Order
          </Button>
          <div className="flex-1">
            <SearchBar placeholder="Search by customer, ref, product..." />
          </div>
        </div>

        <div className="card p-0 flex-1 overflow-auto">
          <table>
            <thead>
              <tr className="sticky top-0 z-10 backdrop-blur bg-gray-50 bg-opacity-80 dark:bg-gray-700/50">
                <th className="px-4 py-3">Order (Ref)</th>
                <th className="px-4">Customer</th>
                <th className="px-4">State</th>
                <th className="px-4">Odoo</th>
                <th className="px-4 text-right">Created</th>
              </tr>
            </thead>
            <tbody>
              {data.orders.results.map((order) => (
                <tr key={order.id} className="border-t dark:border-gray-700">
                  <td className="px-4">
                    <Link to={`${order.id}`}>
                      #{order.id}
                      {order.odooSalesOrderClientOrderRef
                        ? ` (${order.odooSalesOrderClientOrderRef})`
                        : null}
                    </Link>
                  </td>
                  <td className="px-4">
                    {order.customer ? order.customer.name : "N/A"}
                  </td>
                  <td className="px-3">
                    <Status status={order.state} />
                  </td>
                  <td className="px-4">
                    {order.odooSalesOrderId ? (
                      <a
                        target="_blank"
                        className="text-purple-600 flex items-center space-x-1"
                        rel="noreferrer"
                        href={`${odooUrl}/web#id=${order.odooSalesOrderId}&cids=1&menu_id=408&action=312&model=sale.order&view_type=form`}
                      >
                        {order.odooSalesOrderName}
                      </a>
                    ) : null}
                  </td>
                  <td className="px-4 text-right opacity-70">
                    {moment(order.createdAt).format("YYYY-MM-DD HH:mm A")} by{" "}
                    {order.createdBy ? order.createdBy.email : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div>
          <p>
            This page is designed to create sales orders for AB warehouses. The
            sales orders will consume the stock in WIS - Amazon Vendor Center /
            Stock page, and it will be created to Odoo automatically once you
            start planning.
          </p>
          <p>Please contact Charlie if you have any questions.</p>
        </div>
      </div>
    </PageV2>
  );
};

export default OrderList;
